import axios from "axios";

const api = axios.create({
  baseURL: "https://mavericks-vzdh.vercel.app/api/",
  // baseURL: "http://localhost:5000/api/",
  // withCredentials: true, //for cookies to be passed
  headers: {
    "Content-type": "application/json",
    Accept: "application/json",
  },
});

// List of all the endpoints
export const signin = (data) => api.post("/auth/signin", data); //sign in
export const register = (data) => api.post("/auth/register", data);
export const logout = (data) => api.get("/auth/logout");
export const refreshUser = (data) => api.get(`/auth/refresh/${data}`); //send refresh token to get access token as coookie because it is expired

export const Createpost = (data) => {
  // console.log(data);
  return api.post("/post", data);
};
export const getPosts = ({ skip, access }) => {
  // console.log(`post/getPosts/${date}/${access}`);
  return api.get(`post/getPosts/${skip}/${access}`);
};
export const getPost = ({ id, access }) => {
  // console.log(`post/getPosts/${date}/${access}`);
  return api.get(`post/getPost/${id}/${access}`);
};
export const getUserPosts = ({ access }) => {
  // console.log(`post/getPosts/${date}/${access}`);
  return api.get(`post/getUserPosts/${access}`);
};
export const removeTokens = ({ access, tokens }) => {
  // console.log(`post/getPosts/${date}/${access}`);
  return api.get(`user/${tokens}/${access}`);
};

export const getFollowings = ({ access }) =>
  api.get(`/user/followings/${access}`);
export const addFollower = (request, access) =>
  api.post("/user/followers", { request, access });
export const unfollow = (data) =>
  api.post("/user/unfollow", { unfollow: data });
export const getUser = (data) => {
  return api.get(`/user/about/${data.usn}`);
};
export const getSuggestions = (data) => {
  console.log(data.access, data, "9999");
  return api.get(`/user/suggestion/${data.access}`);
};
export const updateUser = (data) => {
  // console.log(data.access, data, "9999");
  return api.put(`/user`, data);
};
export const searchUser = (data, access) => {
  // console.log(data, access);
  // console.log(
  //   `/auth/search/${data}/${access ? access : "nouser"}?onlyfollowers=${
  //     access ? true : false
  //   }`
  // );
  return api.get(
    `/auth/search/${data}/${access ? access : "nouser"}?onlyfollowers=${
      access ? true : false
    }`
  );
};
export const followrequest = (data, access) =>
  api.post(`/user/followrequest/`, { follow: data, access });
export const removerequest = (data, access) =>
  api.post(`/user/removerequest/`, { unfollow: data, access });

export const addComment = (data) =>
  api.post("/post/comments/", { data, access: data.access });
export const getComments = (data) => api.post("/post/getcomments/", data);
export const addLike = (data) => {
  // console.log(data);
  return api.post("/post/addLike/", { data, access: data.access });
};
export const getChats = ({ access }) => {
  return api.get(`/chat/allChats/${access}`);
};
export const getChat = (data) => {
  return api.post("/chat/chat", data);
};

export const getChatId = (data) => {
  // console.log(`/chat/chatId/${data.otherUserId}/${data.access}`);
  return api.get(`/chat/chatId/${data.otherUserId}/${data.access}`);
};
export const getAllMessages = (data) => {
  return api.get(`/chat/message/${data.chatId}/${data.access}/`);
};
export const createMessage = (data) => {
  return api.post(`/chat/message`, data);
};
